import { render, staticRenderFns } from "./color.vue?vue&type=template&id=d9be48d4&scoped=true&"
import script from "./color.vue?vue&type=script&lang=ts&"
export * from "./color.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9be48d4",
  null
  
)

export default component.exports